import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import * as vars from 'variables';
import SearchBoxContainer from '../components/SearchBoxContainer';

export default function setupSearchbox() {
	const isSearchPage = __globalJsData.isSearchPage;
	// do render only if the dom handle is on page
	const searchbox = document.getElementById('js-searchboxReact');
	if (searchbox) {
		// get the q from the query or empty string if not defined
		const initialTerm = vars._GetParams.q ? decodeURIComponent(vars._GetParams.q) : '';
		ReactDOM.render(<SearchBoxContainer initialTerm={initialTerm} isSearchPage={isSearchPage} />, searchbox);
	}
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/setupSearchbox.js
 **/